module.exports = __webpack_public_path__ + "static/PRO004_Banner-caff8d25c1cd665805b503a2543d1833.jpg";